import React from "react"
import * as Yup from "yup"
import { Text, VStack } from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"
import * as api from "api/events"
import { useQueryClient } from "react-query"
import { successToast } from "utilities/toasts"
import { eventCacheKey } from "queries/events"

interface Props {
  eventId: string
  googleAnalyticsMeasurementId: string | null
  onHide: () => void
}

const GoogleAnalyticsModal = ({
  eventId, googleAnalyticsMeasurementId, onHide,
}: Props) => {
  const queryClient = useQueryClient()

  const onSubmit = (values: { googleAnalyticsMeasurementId: string | null }) => {
    const measurementId = values.googleAnalyticsMeasurementId || null

    return api.putEvent(eventId, { googleAnalyticsMeasurementId: measurementId } as any)
      .then(({ data }) => {
        queryClient.setQueryData(
          eventCacheKey(eventId),
          (oldData: any) => ({ ...oldData, ...data }),
        )
        successToast({ title: "Google Analytics updated" })
        onHide()
      })
  }

  const validationSchema = Yup.object().shape({
    googleAnalyticsMeasurementId: Yup.string()
      .nullable()
      .matches(/^G-[A-Z0-9]+$/, "Please enter a valid Measurement ID (format: G-XXXXXXXXXX)"),
  })

  return (
    <ModalForm
      title="Google Analytics"
      size="xl"
      onClose={onHide}
      initialValues={{
        googleAnalyticsMeasurementId: googleAnalyticsMeasurementId || "",
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <VStack spacing={8} align="stretch">
          <Text fontSize="md">
            Connect your Google Analytics account to track traffic and engagement across both the
            Event Web Page and the Guest Portal.
          </Text>
          <TextField
            name="googleAnalyticsMeasurementId"
            control={control}
            label="Measurement ID"
            variant="outline"
            placeholder="G-XXXXXXXXXX"
            helperText="Enter your Measurement ID (format: G-XXXXXXXXXX) to enable Google Analytics tracking."
            labelNoWrap
          />
        </VStack>
      )}
    </ModalForm>
  )
}

export default GoogleAnalyticsModal
